var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, createBlock as _createBlock, Fragment as _Fragment } from "vue";
import _imports_0 from '../../../assets/svg/google.svg';
import _imports_1 from '../../../assets/svg/godaddy.svg';
import _imports_2 from '../../../assets/svg/cloudflare.svg';
import _imports_3 from '../../../assets/svg/ionos.svg';
const _hoisted_1 = { class: "flex justify-center pt-3 pb-5" };
const _hoisted_2 = {
    key: 0,
    alt: "google domain",
    src: _imports_0,
    width: "300",
    height: "300"
};
const _hoisted_3 = {
    key: 1,
    alt: "godaddy",
    src: _imports_1,
    width: "300",
    height: "300"
};
const _hoisted_4 = {
    key: 2,
    alt: "cloudflare",
    src: _imports_2,
    width: "300",
    height: "300"
};
const _hoisted_5 = {
    key: 3,
    alt: "ionos",
    src: _imports_3,
    width: "300",
    height: "300"
};
const _hoisted_6 = {
    key: 0,
    class: "mt-3"
};
const _hoisted_7 = {
    key: 1,
    class: "mt-3"
};
const _hoisted_8 = {
    key: 2,
    class: "mt-3"
};
const _hoisted_9 = { class: "mt-8 -mx-6 border-t-2" };
const _hoisted_10 = { class: "flex items-center justify-end gap-3 px-6 pt-6" };
import { useVerification } from '@/composition/useVerification';
import { DOMAIN_CONNECT_PROVIDERS, } from '@/types';
import { RefreshCcw03Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIAlert, UIButton, UICollapse, UICollapseItem, UITextLgMedium, } from '@gohighlevel/ghl-ui';
import { inject, onMounted, onUnmounted, ref } from 'vue';
import DomainConnectRecordTable from './DomainConnectRecordTable.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DomainConnectAuthorization',
    props: {
        provider: null,
        configuration: null,
        template: null,
        domain: null,
        authorizeUrl: null,
        subDomainValue: null,
        recordTableData: null,
        team: null
    },
    emits: ["closeModal", "resetState"],
    setup(__props, { emit }) {
        const props = __props;
        const isCompleted = ref(false);
        const emitter = inject('emitter');
        const timer = ref();
        const { isErrorVerifyingDomain, isLoading, onAuthorized, onReceivedConfirmation, } = useVerification();
        const addRecord = () => __awaiter(this, void 0, void 0, function* () {
            if (isCompleted.value) {
                onAuthorized({
                    domain: props.domain,
                    addRootOrWWW: props.configuration.addRootOrWWW,
                    subdomain: props.subDomainValue,
                    template: props.template,
                    team: props.team,
                });
            }
            else {
                isLoading.value = true;
                const newWindow = window.open(props.authorizeUrl, '_blank');
                if (newWindow) {
                    const checkWindowClosed = () => {
                        if (newWindow.closed && isLoading.value && !isCompleted.value) {
                            isLoading.value = false;
                            isCompleted.value = true;
                            onAuthorized({
                                domain: props.domain,
                                addRootOrWWW: props.configuration.addRootOrWWW,
                                subdomain: props.subDomainValue,
                                template: props.template,
                                team: props.team,
                            });
                        }
                        else {
                            timer.value = setTimeout(checkWindowClosed, 2000); // check every 2sec
                        }
                    };
                    checkWindowClosed();
                }
            }
        });
        onMounted(() => {
            emitter.on('onReceiveDomainConnectConfirmation', (payload) => {
                onReceivedConfirmation(payload);
                if (payload.flag) {
                    emitter.off('onReceiveDomainConnectConfirmation');
                    emit('closeModal');
                }
            });
        });
        onUnmounted(() => {
            emitter.off('onReceiveDomainConnectConfirmation');
            if (timer.value) {
                clearTimeout(timer.value);
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(UITextLgMedium), { class: "py-3 font-semibold" }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('domainProviderTitle')), 1)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_1, [
                    (__props.provider === _unref(DOMAIN_CONNECT_PROVIDERS).GOOGLE_DOMAIN)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                        : (__props.provider === _unref(DOMAIN_CONNECT_PROVIDERS).GO_DADDY)
                            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                            : (__props.provider === _unref(DOMAIN_CONNECT_PROVIDERS).CLOUDFLARE)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                                : (__props.provider === _unref(DOMAIN_CONNECT_PROVIDERS).IONOS)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                                    : _createCommentVNode("", true)
                ]),
                _createVNode(_unref(UICollapse), { "arrow-placement": "right" }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(UICollapseItem), {
                            title: _ctx.$t('expandRecordTitle'),
                            name: "expandRecord",
                            id: "1"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(DomainConnectRecordTable, { recordTableData: __props.recordTableData }, null, 8, ["recordTableData"])
                            ]),
                            _: 1
                        }, 8, ["title"])
                    ]),
                    _: 1
                }),
                (_unref(isErrorVerifyingDomain).state)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_unref(UIAlert), {
                            id: "verifyDomainError",
                            type: 'error'
                        }, _createSlots({
                            title: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('verifyDomainErrorTitle')), 1)
                            ]),
                            _: 2
                        }, [
                            (_unref(isErrorVerifyingDomain).errorMessage)
                                ? {
                                    name: "content",
                                    fn: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(isErrorVerifyingDomain).errorMessage), 1)
                                    ]),
                                    key: "0"
                                }
                                : undefined
                        ]), 1024)
                    ]))
                    : (!_unref(isErrorVerifyingDomain).state && _unref(isLoading) && isCompleted.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(UIAlert), {
                                id: "verifyingDomainWarning",
                                type: 'warning'
                            }, {
                                title: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('verifyDomainWarningTitle')), 1)
                                ]),
                                _: 1
                            })
                        ]))
                        : (!_unref(isErrorVerifyingDomain).state && _unref(isLoading) && !isCompleted.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                _createVNode(_unref(UIAlert), {
                                    id: "verifyingDomainInfo",
                                    type: 'info'
                                }, {
                                    title: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('verifyDomainInfoTitle')), 1)
                                    ]),
                                    _: 1
                                })
                            ]))
                            : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_unref(UIButton), {
                            id: "back",
                            disabled: _unref(isLoading),
                            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('resetState')))
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('back')), 1)
                            ]),
                            _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_unref(UIButton), {
                            loading: _unref(isLoading),
                            circle: false,
                            onClick: addRecord,
                            id: "addedRecord",
                            type: "primary"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(isLoading)
                                    ? _ctx.$t('authorizing')
                                    : isCompleted.value
                                        ? _ctx.$t('tryAgain')
                                        : _ctx.$t('authorizeDomain')) + " ", 1),
                                (isCompleted.value && !_unref(isLoading))
                                    ? (_openBlock(), _createBlock(_unref(RefreshCcw03Icon), {
                                        key: 0,
                                        class: "w-4 h-4 ml-2"
                                    }))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        }, 8, ["loading"])
                    ])
                ])
            ], 64));
        };
    }
});
